module.exports = __webpack_public_path__ + "images/kaitori_bonus_cp_lp/6th/mainvisual-present@2x_1e8f228bd0d793771d4a1c3086e71cf8.png";